export default "__VITE_ASSET__DN0R_G01__"